import {
  type FilterTableItemDescriptor,
  generateHeadersAndFilters,
} from "../../../../../Components/FilterTable/filterTableUtils";
import { type WizAssetRowData } from "./WizAssetRow";

const wizItemDescriptors: FilterTableItemDescriptor<WizAssetRowData>[] = [
  {
    headerText: "Tenant ID",
    value: "orgId",
    filterType: "string",
  },
  {
    headerText: "Tenant Name",
    value: "orgName",
    filterType: "string",
  },
  {
    headerText: "Status",
    value: "status",
    filterType: "string",
  },
];

const { filters, headerColumns: baseHeaderColumns } = generateHeadersAndFilters(wizItemDescriptors);
const headerColumns = [...baseHeaderColumns] as const;

export { filters, headerColumns };
